import { render, staticRenderFns } from "./qualityProject.vue?vue&type=template&id=b4c0bf26&scoped=true&"
import script from "./qualityProject.vue?vue&type=script&lang=js&"
export * from "./qualityProject.vue?vue&type=script&lang=js&"
import style0 from "./qualityProject.vue?vue&type=style&index=0&id=b4c0bf26&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4c0bf26",
  null
  
)

export default component.exports